import { format, isValid, parseISO } from 'date-fns';
import orderBy from 'lodash.orderby';

import { BOOKKEEPING_PRODUCT_CODES_ARR } from '_constants/products';

export const createOrderOptions = (data = []) => {
  const filteredData = data?.filter(({ products }) => {
    return products?.find(({ code: { code, main } }) => BOOKKEEPING_PRODUCT_CODES_ARR.includes(code) && main);
  });

  const sortedData = orderBy(filteredData, ['orderDate'], ['desc']);

  const mappedData = sortedData?.map(({ uid, products: orderProducts, orderDate, parent }) => {
    const products = parent ? parent.products : orderProducts;

    let companyNameOrOwner = products?.find(({ companyName }) => companyName)?.companyName;

    if (!companyNameOrOwner) {
      companyNameOrOwner = products?.find(({ legalName }) => legalName)?.legalName;
    }

    if (!companyNameOrOwner) {
      companyNameOrOwner = products?.find(({ dbaname }) => dbaname)?.dbaname;
    }

    if (!companyNameOrOwner) {
      let { firstName, lastName } = products?.find(({ owner }) => owner?.firstName)?.owner || {};
      companyNameOrOwner = `${firstName} ${lastName}`;
    }

    if (isValid(parseISO(orderDate))) {
      return { title: `${companyNameOrOwner} (${format(parseISO(orderDate), 'MM/dd/yyyy')})`, value: uid };
    }

    return { title: `${companyNameOrOwner} (${orderDate})`, value: uid };
  });

  return mappedData;
};
